import {Form, Input, message, Modal, ModalProps} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import useRequestFn from '../../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../../Utils/common';
import {editPlatform, PlatformList, SavePlatform} from '../../service';

interface Props extends ModalProps {
    onOk: () => void;
    data?: PlatformList;
}

const Index = ({onOk, data, ...props}: Props) => {
    const [form] = Form.useForm<SavePlatform>();
    const [save, {loading: saveLoading}] = useRequestFn(editPlatform);

    async function onFinish(formData: SavePlatform) {
        try {
            if (data?.id) {
                formData.id = data?.id;
            }
            await save(formData);
            message.success('编辑成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            width={600}
            title="编辑网站"
            confirmLoading={saveLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    labelCol={{span: 7}}
                    initialValues={data}>
                    <Form.Item
                        name="userName"
                        label="用户名"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="密码"
                        rules={[{required: true}]}>
                        <Input.Password placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="loginHandlerWechatNumber"
                        label="登陆提醒人微信号"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default Index;
